import QualityList from './jobeden/QualityList';
import OrientationPoll from './jobeden/OrientationPoll';
import SelectionList from './jobeden/SelectionList';

export default {
    install(Vue){
        Vue.mixin({
            created() {
                const jcomp = {QualityList,OrientationPoll,SelectionList}
                for(let key in jcomp){
                    Vue.component('j'+key,jcomp[key]);
                }
            }
        });
    }
}
